module.exports = __webpack_public_path__ + "img/chem-1.cb31d988.png";